// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2uF03","title":"Info_title__2moGS","selects":"Info_selects__3SzJ4","requiredAsterisk":"Info_requiredAsterisk__tE8A-"};